// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__vG6u-","list":"Tags_list__sD2Q1","label":"Tags_label__6R8PM","tooltip":"Tags_tooltip__d4p2l"};